import { AppBar, Box, Button, Chip, IconButton, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

import { can, roleLabel } from '../auth/capabilities.js';
import { useAuth } from '../auth/useAuth.js';

import { NotificationBell } from './NotificationBell.js';

export function Header({ onMenu }: { onMenu: () => void }): JSX.Element {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async (): Promise<void> => {
    await logout();
    navigate('/login');
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{ left: { xs: 0, md: 256 }, width: { xs: '100%', md: 'calc(100% - 256px)' } }}
    >
      <Toolbar sx={{ gap: 2 }}>
        <IconButton
          color="inherit"
          onClick={onMenu}
          aria-label="Open navigation"
          sx={{ display: { md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          variant="overline"
          sx={{
            flexGrow: 1,
            color: 'text.secondary',
            letterSpacing: '0.24em',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          ADMINISTRATION CONSOLE
        </Typography>
        {user !== null && (
          <Box display="flex" alignItems="center" gap={2} sx={{ ml: 'auto' }}>
            {/* On every page, not just the dashboard — money waiting on a
                decision should not depend on somebody happening to look. */}
            {can(user.role, 'console') && <NotificationBell />}
            <Chip label={roleLabel(user.role)} size="small" color="primary" variant="outlined" />
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', display: { xs: 'none', lg: 'block' } }}
            >
              {user.email}
            </Typography>
            <Button onClick={() => void onLogout()} color="inherit" size="small">
              Sign out
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
